<template>
  <div class="dialog" ref="dialog">
    <div class="content">
      <div class="top">
        <slot name="header" class="title"> header </slot>
      </div>
      <div class="body">
        <slot name="content"></slot>
      </div>
      <div class="bottom">
        <button v-if="!isInfo" class="btn" @click="cancel">Cancel</button>
        <button class="btn warning" @click="confirm">{{ confirmName }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from '@eds/vanilla';

export default {
  props: {
    confirmName: {
      type: String,
      default: 'Ok',
    },
    isOpen: Boolean,
    isInfo: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isOpen: function() {
      this.open();
    }
  },

  data() {
    return {
      dialog: Dialog,
    };
  },

  mounted() {
    this.dialog = new Dialog(this.$refs.dialog);
  },

  methods: {
    open() {
      this.dialog.show();
    },

    hide() {
      this.dialog.hide();
    },

    cancel() {
      this.dialog.hide();
      this.$emit('cancel');
    },

    confirm() {
      this.dialog.hide();

      if (!this.isInfo) {
        this.$emit('confirm');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.confirmation {
  margin: auto;
  position: 0;
}
</style>